module.exports = __webpack_public_path__ + "static/c_teo-c0287a7bdfb4d9697a9acfe758bcf2fb.jpg";